import {
    UPDATE_ERROR_MSG,
} from '../../../../actionTypes';

const INITIAL_STATE = {
    errorMessage: ''
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case UPDATE_ERROR_MSG:
            return { ...state, errorMessage: action.payload };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/scenes/LoginPage/services/loginFeedback/reducer.js